import React, { HTMLAttributes } from "react";
import classnames from "classnames";

import { Fader } from "./Fader";
import styles from "./LoadingIndicator.module.scss";

export interface ILoadingIndicatorProps {
    visible: boolean;
    topAligned?: boolean;
}

export function LoadingIndicator(
    props: ILoadingIndicatorProps & HTMLAttributes<HTMLDivElement>,
) {
    const { visible, topAligned, className, ...rest } = props;

    return (
        <Fader
            visible={visible}
            className={classnames(
                styles["loading-indicator"],
                topAligned && styles.topAligned,
            )}
            {...rest}
        />
    );
}
